import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* getProfile() {
    yield takeEvery(actions.FETCH_PROFILE_REQUESTED, function* (action) {
        try {
          const profile = yield call(actions.getCurrentProfile, action.payload);
          yield put({ type: actions.FETCH_PROFILE_SUCCEEDED, profile });
        } catch (error) {
          yield put({ type: actions.FETCH_PROFILE_FAILED, error: error.response?.data?.message });
        }
    });
}

export function* updateProfile() {
    yield takeEvery(actions.UPDATE_PROFILE_REQUESTED, function* (action) {
        try {
            const profile = yield call(actions.updateCurrentProfile, action.payload);
            localStorage.setItem('user', JSON.stringify(profile?.user_info));
            yield put({ type: actions.UPDATE_PROFILE_SUCCEEDED, profile });
        } catch (error) {
            yield put({ type: actions.UPDATE_PROFILE_FAILED, error: error.response?.data?.message });
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(getProfile),
        fork(updateProfile)
    ]);
}
